export default "__VITE_ASSET__CSjGGAY7__"